import styled from 'styled-components';

export const Container = styled.aside`
  background: #2a3142;
  min-width: 240px;
  display: ${props => (props.menus ? 'flex' : 'none')};
  flex-direction: column;
  font-family: Sarabun, sans-serif;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  a {
    padding: 15px 0;
    display: flex;
    justify-content: center;
    img {
      width: 70%;
    }
  }

  @media (max-width: 1200px) {
    min-width: 20vw;
  }

  @media (max-width: 800px) {
    min-width: 30vw;
  }

  @media (max-width: 600px) {
    min-width: 60vw;
  }
`;

export const Itens = styled.div`
  display: flex;
  flex-direction: column;

  > span {
    color: #b4bfcc;
    text-transform: uppercase;
    padding: 0 20px;
    font-size: 12px;
    margin-bottom: 15px;
    margin-top: 20px;
  }
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  padding: 20px;
  /* margin-bottom: 10px; */
  background: ${props => (props.active ? '#626ed4' : 'none')};
  border: 0;

  /* &:hover {
    background: #626ed4;
  } */

  svg {
    margin-right: 10px;
  }

  span {
    color: #fff;
    vertical-align: middle;
    font-size: 15.7px;
  }
`;
export const Top = styled.div`
  background: #626ed4;
`;
